import { render } from "./RandomizationModal.vue?vue&type=template&id=7f6dd48c"
import script from "./RandomizationModal.js?vue&type=script&lang=js"
export * from "./RandomizationModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__